/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file ConstructionAccessAssessmentView.jsx
 * @author Daniel Aguirre
 * @description ConstructionAccessAssessment View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * ConstructionAccessAssessment View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function ConstructionAccessAssessmentView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getConstructionAccessAssessment } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Solicitado y valorado',
        classification: 'Solicitado y valorado',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'Solicitado y NO valorado',
        classification: 'Solicitado y NO valorado',
        color: styleGuideColors.baxterBrandBaxterBlue
      },
      {
        label: 'No solicitado',
        classification: 'No solicitado',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, classification, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === classification
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              color,
              cantidad: respElement.cantidad,
              classification
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getConstructionAccessAssessment({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (index) => {
    const { classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/construction-access-assessment-list/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F24" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.constructionAccessAssessment')}
        dataValues={chartData || []}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
ConstructionAccessAssessmentView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getConstructionAccessAssessment: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default ConstructionAccessAssessmentView;
